module.exports = __webpack_public_path__ + "media/college_scholarships/apply-to-win-5e58c423.png";